// extracted by mini-css-extract-plugin
export var discard = "_4v-3";
export var muiTooltipTooltip = "_4v-5";
export var notificationBar = "_4v-2";
export var saveButtonHoverSlotWrapper = "_4v-4";
export var show = "_4v-1";
export var spacer = "_4v-0";